import { getNetPayableBreakdown, getPayableOverrides, type PayableCampaignInput } from './paymentCalculations';

type EmailCampaign = PayableCampaignInput & { net_fee_influencer?: number };

/**
 * Deductions withheld on this payout. The payable figures shown everywhere
 * are already net of them, so this is informational: it says how much of
 * the gross was withheld, never a second subtraction.
 */
export function getExpensesTotalFor(campaigns: EmailCampaign[]): number {
  return campaigns.reduce(
    (sum, c) => sum + getNetPayableBreakdown(c, getPayableOverrides(c)).deductionsApplied,
    0
  );
}
